import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  filterCheckboxText: {
    color: theme.palette.common.white,
    fontWeight: 500
  },
  filterCheckbox: {
    width: '100%',
    backgroundColor: theme.palette.common.checkboxBox,
    color: theme.palette.common.white,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  checkbox: {
    color: theme.palette.common.white,
    '&$checked': {
      color: theme.palette.common.white,
      fontSize: 24,
      '> svg': {
        fontSize: 24
      }
    },
    '&$disabled': {
      color: theme.palette.common.white
    }
  },
  checked: {},
  disabled: {},
  chipCheckbox: {
    fontWeight: 500,
    marginRight: theme.spacing(1.25),
    backgroundColor: 'transparent',
    color: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.white}`,
    '&:first-child': {
      marginLeft: 0,
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1.25)
      }
    }
  },
  root: {
    display: 'flex',
    marginLeft: '0 !important',
    marginRight: '0 !important',
    padding: theme.spacing(1, 0),
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1, 0),
      alignItems: 'center'
    }
  },
  labelBox: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 0,
    marginRight: 0,
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    }
  },
  fontSizeSmall: {
    fontSize: 24
  },
  iconRoot: {
    fontSize: 24,
    color: theme.palette.common.white
  }
}));
